<nav class="landing-navbar">
    <div class="navbar-container">
        <div class="navbar-logo">
            <img src="assets/logo_dark_theme.png" alt="Radio Ads Direct" />
        </div>

        <div class="navbar-links">
            <div class="navbar-dropdown-container">
                <a (click)="toggleSolutions()" class="nav-link dropdown-trigger">
                    Solutions
                    <span class="dropdown-arrow">▼</span>
                </a>
                <div class="dropdown-menu" *ngIf="showSolutionsDropdown">
                    <a *ngFor="let item of solutionsItems" [href]="item.link" class="dropdown-item">
                        {{ item.label }}
                    </a>
                </div>
            </div>

            <a href="#why-radio" class="nav-link">Why Radio?</a>
            <a href="#pricing" class="nav-link">Pricing</a>

            <div class="navbar-dropdown-container">
                <a (click)="toggleResources()" class="nav-link dropdown-trigger">
                    Resources
                    <span class="dropdown-arrow">▼</span>
                </a>
                <div class="dropdown-menu" *ngIf="showResourcesDropdown">
                    <a *ngFor="let item of resourcesItems" [href]="item.link" class="dropdown-item">
                        {{ item.label }}
                    </a>
                </div>
            </div>

            <a href="#contact" class="nav-link">Contact</a>
        </div>

        <div class="navbar-actions">
            <button class="login-button" routerLink="/login">Login</button>
        </div>
    </div>
</nav>